import { actionsEnum } from 'pages/store/actions/defaults';

const sortInitialState = {};

const sort = entity => (state = sortInitialState, action) => {
  const { entity: actionEntity, clearEntities = [], sort: actionSort, type } = action;

  if (entity !== actionEntity && clearEntities.indexOf(entity) === -1) {
    return state;
  }

  switch (type) {
    case actionsEnum.SORT: {
      return {
        sortOrder: actionSort.sortOrder,
        sortKey: actionSort.sortKey,
      };
    }
    case actionsEnum.DATA_CLEAR:
      return sortInitialState;
    default:
      return state;
  }
};

export default sort;
